<div class="modal-top-bar">
    <h3>Parser learning configuration</h3>
</div>
<div class="modal-content nlpm-container mb-4" *ngIf="!!selectedConfiguration">
    <div class="d-flex gap-3">
        <div class="nlpm-field">
            <span>
                Time limit
                <mat-icon class="icon-info" title="Total limit, in hours, to stop learning phase.">info</mat-icon>
            </span>
            <input [(ngModel)]="selectedConfiguration.timeLimitHours" type="number" min="0"/>
        </div>
        <div class="nlpm-field">
            <span>
                Time limit without features
                <mat-icon class="icon-info" title="Limit, in hours, to stop learning when features are not being generated.">info</mat-icon>
            </span>
            <input [(ngModel)]="selectedConfiguration.timeLimitHoursWithoutFeatures" type="number" min="0"/>
        </div>
    </div>
    <div class="nlpm-field">
        <span class="nlpm-field-title">variables</span>
        <div class="nlpm-variables-container" *ngFor="let ds of nodeConfiguration.dataSources">
            <span>{{ds.name}}</span>
            <div class="nlpm-variables">
                <div *ngFor="let variable of ds.configuration.variables">
                    <mat-checkbox [(ngModel)]="variable.selected">{{variable.name}}</mat-checkbox>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-bottom-bar">
  <button class="button outline mini wide" (click)="dialogRef.close()">Cancel</button>
  <button [disabled]="!nodeConfiguration || !selectedConfiguration" class="button mini wide" (click)="execute()">Execute</button>
</div>